import { render, staticRenderFns } from "./MyFeedback.vue?vue&type=template&id=ab1f7a06&scoped=true&"
import script from "./MyFeedback.vue?vue&type=script&lang=js&"
export * from "./MyFeedback.vue?vue&type=script&lang=js&"
import style0 from "./MyFeedback.vue?vue&type=style&index=0&id=ab1f7a06&lang=scss&scoped=true&"
import style1 from "./MyFeedback.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1f7a06",
  null
  
)

export default component.exports